const Container = ({width, height, children, texto, custom}) => {
    return(
        <div className={`${width} ${height} ${custom} bg-white rounded-md border border-[#ECECEC]`}>  
            {texto || children}
        </div>
    );
}
export default Container;